import filter from './filters';
import hours from './hours';

export default {
  install(Vue) {
    Vue.filter('toLocaleDate', filter.toLocaleDate);
    Vue.filter('toLocaleDateTime', filter.toLocaleDateTime);
    Vue.filter('toFirstLetter', filter.toFirstLetter);
      Vue.filter('phaseNameByTypeId', filter.phaseNameByTypeId);
    Vue.filter('asHours', hours);
    Vue.filter('intervalNameByTypeId', filter.intervalNameByTypeId);
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js